"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const max = 0xEFFFFF;
const min = 0x100000;
let counter = ~~(Math.random() * max);
/** 获取一个看似随机的字符串 */
function getRandomMark() {
    counter += 1;
    if (counter > max)
        counter = 0;
    return (counter + min).toString(16);
}
exports.default = getRandomMark;
//# sourceMappingURL=getRandomMark.js.map